import { MEDIA_QUERIES, useMediaQuery } from '@student-coin/coinpaper-components';
import { Fragment, ReactElement, useEffect, useState } from 'react';
import { LinkArticle } from './LinkArticle/LinkArticle';
import { Container, SocialsWrapper } from './ShareArticle.styles';
import { ShareArticleProps } from './ShareArticle.types';
import { SocialShare } from './SocialShare/SocialShare';
import { socials } from './socials';

export const ShareArticle = ({
  articleLink,
  text,
  linkAsIcon = false,
  socialLink = true,
}: ShareArticleProps): ReactElement => {
  const [linkIcon, setLinkIcon] = useState(linkAsIcon);
  const isTabletWide = useMediaQuery(MEDIA_QUERIES.tablet);

  useEffect(() => {
    if (!linkAsIcon && !isTabletWide) {
      setLinkIcon(true);
    } else if (!linkAsIcon && isTabletWide) {
      setLinkIcon(false);
    }
  }, [linkAsIcon, isTabletWide]);

  return (
    <Container className="share-article-container">
      {!linkIcon && <LinkArticle linkAsIcon={linkIcon} articleLink={articleLink} />}
      <SocialsWrapper>
        {socialLink &&
          socials.map((social) => {
            if (social.name === 'Link' || typeof social.icon === 'function') {
              const icon = social.icon as (articleLink: string) => ReactElement;

              return <Fragment key={social.name}>{icon(articleLink)}</Fragment>;
            }
            return (
              <SocialShare
                key={social.name}
                icon={social.icon}
                socialLink={social.socialLink}
                textPrefix={social.textPrefix}
                articleLink={articleLink}
                text={text}
                hoverColor={social.color}
              />
            );
          })}
      </SocialsWrapper>
    </Container>
  );
};
